import React from 'react';
import { Card, Stack, Typography, Box } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

interface TotalPMCostCardProps {
  value: number;
}

const TotalPMCostCard: React.FC<TotalPMCostCardProps> = ({ value }) => {
  return (
    <Card sx={{ flex: 1, minWidth: { xs: '100%', sm: 200 }, border: '1px solid #e2e8f0' }} elevation={0}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
        <Stack spacing={0.5}>
          <Typography variant="body2" sx={{ color: '#64748b' }}>Total Cost</Typography>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>
            ${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Typography>
        </Stack>
        <Box sx={{
          width: 48, height: 48, borderRadius: '50%',
          backgroundColor: '#ec489915', display: 'flex',
          alignItems: 'center', justifyContent: 'center'
        }}>
          <AttachMoneyIcon sx={{ color: '#ec4899', fontSize: 28 }} />
        </Box>
      </Stack>
    </Card>
  );
};

export default TotalPMCostCard;
